
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { ActivityGuideItem } from '@xt/client/types/home.d'
import { isCurrentYear } from '@xt/client/utils/home'
import ActivityCard from './card/activityCard.vue'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import SwiperBtn from './swiperBtn/index.vue'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    NewSwiper,
    ActivityCard,
    SwiperBtn
  }
})
export default class extends Vue {
  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  activeIndex: number = 0

  get dataSource() {
    return this.$store.$homeV2.dataSource
  }

  get dataList(): ActivityGuideItem[][] {
    return lodash.chunk(
      this.dataSource?.activityGuide.map(item => {
        return {
          ...item,
          currentYear: isCurrentYear(item.startTime)
        }
      }),
      4
    )
  }

  handleChange(index) {
    this.activeIndex = index
  }

  prev() {
    if (!this.swiper) return
    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return
    this.swiper.handleNext()
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
